"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStatefulObservable = void 0;
function createStatefulObservable(getInitialValue) {
    var nextFunctions = [];
    var _a = (function () {
        var wrappedState = undefined;
        return {
            "get": function () {
                if (wrappedState === undefined) {
                    wrappedState = [getInitialValue()];
                }
                return wrappedState[0];
            },
            "set": function (data) {
                wrappedState = [data];
                nextFunctions.forEach(function (next) { return next(data); });
            }
        };
    })(), get = _a.get, set = _a.set;
    return Object.defineProperty({
        "current": null,
        "subscribe": function (next) {
            nextFunctions.push(next);
            return { "unsubscribe": function () { return nextFunctions.splice(nextFunctions.indexOf(next), 1); } };
        }
    }, "current", {
        "enumerable": true,
        get: get,
        set: set
    });
}
exports.createStatefulObservable = createStatefulObservable;
//# sourceMappingURL=StatefulObservable.js.map